const PNG_BASE64_PREFIX = 'iVBORw0KGgo';
const PNG_DATA_URL_PREFIX = 'data:image/png;base64,';

const MAX_PNG_BASE64_LENGTH = 7_000_000;

const BASE64_BODY = /^[A-Za-z0-9+/]+={0,2}$/;

const extractPngBase64Payload = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_PNG_BASE64_LENGTH) {
    return null;
  }

  if (trimmed.startsWith(PNG_DATA_URL_PREFIX)) {
    return trimmed.slice(PNG_DATA_URL_PREFIX.length);
  }

  if (trimmed.startsWith('data:')) {
    return null;
  }

  if (trimmed.startsWith(PNG_BASE64_PREFIX)) {
    return trimmed;
  }

  return null;
};


export const isPngBase64FileLink = (value: string): boolean => {
  const payload = extractPngBase64Payload(value);
  if (!payload || !payload.startsWith(PNG_BASE64_PREFIX)) {
    return false;
  }
  return BASE64_BODY.test(payload);
};

export const toPngDataUrl = (value: string): string | null => {
  const payload = extractPngBase64Payload(value);
  if (!payload || !payload.startsWith(PNG_BASE64_PREFIX) || !BASE64_BODY.test(payload)) {
    return null;
  }
  return `${PNG_DATA_URL_PREFIX}${payload}`;
};
